import localStorage_utils from './localStorage';
import { STORAGE_KEYS } from '../data/constants';

// Storage Manager - High-level app-specific storage operations
// Provides app-specific methods for managing different types of data

const storageManager = {
  // Bookmark operations
  bookmarks: {
    load: () => localStorage_utils.bookmarks.get(STORAGE_KEYS.BOOKMARKS),
    save: (bookmarksSet) => localStorage_utils.bookmarks.set(STORAGE_KEYS.BOOKMARKS, bookmarksSet),
    clear: () => localStorage_utils.remove(STORAGE_KEYS.BOOKMARKS)
  },

  // Study progress operations (for future expansion)
  studyProgress: {
    load: () => localStorage_utils.get(STORAGE_KEYS.STUDY_PROGRESS, {}),
    save: (progress) => localStorage_utils.set(STORAGE_KEYS.STUDY_PROGRESS, progress),
    clear: () => localStorage_utils.remove(STORAGE_KEYS.STUDY_PROGRESS)
  },

  // User preferences (for future expansion)
  preferences: {
    load: () => localStorage_utils.get(STORAGE_KEYS.USER_PREFERENCES, {
      practiceMode: false,
      theme: 'light',
      autoStartStudy: true
    }),
    save: (preferences) => localStorage_utils.set(STORAGE_KEYS.USER_PREFERENCES, preferences),
    clear: () => localStorage_utils.remove(STORAGE_KEYS.USER_PREFERENCES)
  },

  // Viewed concepts tracking (for future expansion)
  viewedConcepts: {
    load: () => {
      const viewed = localStorage_utils.get(STORAGE_KEYS.VIEWED_CONCEPTS, []);
      return new Set(viewed);
    },
    save: (viewedSet) => localStorage_utils.set(STORAGE_KEYS.VIEWED_CONCEPTS, [...viewedSet]),
    clear: () => localStorage_utils.remove(STORAGE_KEYS.VIEWED_CONCEPTS)
  },

  // Clear all app data
  clearAll: () => {
    const keys = Object.values(STORAGE_KEYS);
    keys.forEach(key => localStorage_utils.remove(key));
    return true;
  },

  // Get app storage summary
  getStorageSummary: () => {
    const info = localStorage_utils.getStorageInfo();
    if (!info) return null;

    const appKeys = Object.values(STORAGE_KEYS);
    const appData = {};
    let appSize = 0;

    appKeys.forEach(key => {
      if (info.items[key]) {
        appData[key] = info.items[key];
        appSize += info.items[key];
      }
    });

    return {
      totalAppSize: appSize,
      totalAppSizeKB: Math.round(appSize / 1024 * 100) / 100,
      appItems: appData,
      totalSystemSize: info.totalSize,
      totalSystemSizeKB: info.totalSizeKB
    };
  },

  // Migrate old storage format (for backward compatibility)
  migrateOldData: () => {
    try {
      // Check for old bookmark format
      const oldBookmarks = localStorage_utils.get('secplus-bookmarks', null);
      if (oldBookmarks && Array.isArray(oldBookmarks)) {
        storageManager.bookmarks.save(new Set(oldBookmarks));
        localStorage_utils.remove('secplus-bookmarks');
        console.log('Migrated old bookmark data to new format');
      }
      return true;
    } catch (error) {
      console.warn('Failed to migrate old data:', error);
      return false;
    }
  }
};

export default storageManager;